import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import { CalendarCheckRegularV6 } from "@shared/v2/Icomoon";
import CardAppointmentMenu from "../tasks/CardAppointmentMenu";
import AppointmentDueDate from "../tasks/AppointmentDueDate";
import CardDetail from "../tasks/CardDetail";

const ViewAllAppointmentsModal = ({
  onClose,
  completeTask,
  showTaskDetails,
  onDeleteTask,
  editTask,
  showViewAllModal,
  viewAllAppointments,
}) => (
  <Modal
    id="view-all-appointments-modal"
    show={showViewAllModal}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[800px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="All Appointments" closeButton />

    <Modal.Body className="tw-flex-1 tw-overflow-auto tw-flex tw-flex-col tw-gap-[24px]">
      {viewAllAppointments.map((task) => (
        <div
          className="tw-border-[2px] tw-border-[#EBEBEB] tw-border-solid tw-rounded-[4px] tw-p-[15px] tw-flex tw-gap-[16px]"
          key={task.id}
        >
          <div className="tw-flex-none tw-w-[42px] tw-h-[42px] tw-border-solid tw-border-[2px] tw-rounded-full tw-flex tw-justify-center tw-items-center">
            <CalendarCheckRegularV6 size="l" />
          </div>

          <div className="tw-flex-1">
            <div className="tw-flex tw-items-center tw-font-semibold tw-text-12 tw-text-gray-75">
              {task.name}
            </div>

            <AppointmentDueDate
              dueness={task.dueness}
              dueDate={task.calculated_due_on || task.due_on}
              scheduledTime={task.scheduled_time}
              preferScheduledTime
            />

            <div className="tw-pt-[16px] tw-flex tw-flex-col tw-gap-[8px]">
              {task.appointment_type && <CardDetail title="Type" value={task.appointment_type} />}
              <CardDetail title="Status" value={task.completed_at ? "Completed" : "Scheduled"} />
              {task.location && <CardDetail title="Location" value={task.location} />}
              {task.outcome && <CardDetail title="Outcome" value={task.outcome} />}
              {task.note && <CardDetail title="Notes" value={task.note} />}
            </div>
          </div>

          <CardAppointmentMenu
            editFn={() => editTask(task)}
            completeFn={() => completeTask(task)}
            viewDetailsFn={() => showTaskDetails(task)}
            deleteAppointmentFn={() => onDeleteTask(task)}
            isCompleted={task.state === "completed"}
            btnSize="medium"
          />
        </div>
      ))}
    </Modal.Body>
  </Modal>
);

ViewAllAppointmentsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  showTaskDetails: PropTypes.func.isRequired,
  onDeleteTask: PropTypes.func.isRequired,
  editTask: PropTypes.func.isRequired,
  completeTask: PropTypes.func.isRequired,
  showViewAllModal: PropTypes.bool.isRequired,
  viewAllAppointments: PropTypes.arrayOf(PropTypes.shape({})),
};

ViewAllAppointmentsModal.defaultProps = {
  viewAllAppointments: [],
};

export default ViewAllAppointmentsModal;
